import { useEffect } from "react";
import isEmpty from "lodash.isempty";
import {
  useWatch,
  useFormState,
  useFormContext,
  useController,
} from "react-hook-form";

import { useAuth } from "providers/Auth";
import AnnotationItem from "../AnnotationItem";
import { verifyState } from "config/const";

function getHelperText({ status }) {
  switch (status) {
    case verifyState.UNVERIFY:
    case verifyState.VERIFYING:
      return "請驗證手機";
    case verifyState.VERIFIED:
    default:
      return " ";
  }
}
export default function PhoneVerify({ item, defaultValue }) {
  const { profile } = useAuth();
  const phone = useWatch({ name: "phone", defaultValue });
  const status = useWatch({
    name: "phoneVerifyStatus",
    defaultValue: verifyState.VERIFIED,
  });
  useController({
    name: "verifiedToken",
    // rules: { required: phone !== defaultValue || isError },
  });
  const { setValue } = useFormContext();
  const { errors } = useFormState({ name: "phone", exact: true });
  const validPhone = phone && isEmpty(errors["phone"]);

  const verifyHelperText = getHelperText({ status });

  useEffect(() => {
    if (validPhone && phone === defaultValue) return;
    setValue("verifiedToken", undefined);
  }, [phone]);

  const disabled =
    status === verifyState.VERIFIED || !phone || !phone.match(/^(09)[0-9]{8}$/);

  return (
    <AnnotationItem
      annotation={item}
      helperText={verifyHelperText}
      disabled={disabled}
    />
  );
}
